<template>
  <div v-if="isEditing">
    <el-form-item prop="title" label="题目">
      <wjQuillEditor :content="tempQuesData.title" :config="config" @onChange="handleEditorChange"></wjQuillEditor>
    </el-form-item>
    <el-form-item label="备注">
      <el-input class="editor-input" v-model="tempQuesData.description"></el-input>
    </el-form-item>
    <el-collapse
      v-model="advancedSetting"
      @change="handleSettingChange"
      class="batchChange backgroundGray"
    >
      <el-collapse-item name="1">
        <template slot="title">
          <div class="advanced-setting-title backgroundGray">
            <span class="more-setting-btn">
              {{advancedSettingTitle}}
              <i :class="advanceSettingIcon"></i>
            </span>
          </div>
        </template>
        <div class="backgroundGray">
          <div class="edit-settings">
            <el-form-item label="行高尺寸">
              <el-select class="maxSelectInput" v-model="tempQuesData.rows" size="mini">
                <el-option label="不限" :value="0"></el-option>
                <el-option label="1" :value="1"></el-option>
                <el-option label="2" :value="2"></el-option>
                <el-option label="3" :value="3"></el-option>
                <el-option label="4" :value="4"></el-option>
                <el-option label="5" :value="5"></el-option>
                <el-option label="6" :value="6"></el-option>
                <el-option label="7" :value="7"></el-option>
                <el-option label="8" :value="8"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="最多填写">
              <el-input-number
                v-model="tempQuesData.maxLength"
                controls-position="right"
                size="mini"
              ></el-input-number>
              <span>字</span>
            </el-form-item>
            <el-form-item label="验证规则" class="left20">
              <el-select v-model="tempQuesData.validate" size="mini">
                <el-option
                  v-for="(item, index) in validateOptions"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
  <div v-else>
    <div class="ques-title">
      {{ ques.index + 1 }}.
      <p style="display: inline-block;" v-html="ques.title"></p>
      <i v-if="ques.required" class="required-icon">*</i>
    </div>
    <p class="ques-desc">{{ ques.description }}</p>
    <el-input type="textarea" :rows="ques.rows" resize="none" placeholder="请输入内容"></el-input>
  </div>
</template>
<script>
import wjQuillEditor from "./wj-quill-editor.vue";
import { quesMixin } from '../utils/mixins'
export default {
  name: "textArea",
  mixins: [quesMixin],
  data() {
    return {
      validateOptions: [
        {
          label: "不限",
          value: ""
        },
        {
          label: "电子邮箱",
          value: "emial"
        },
        {
          label: "中文",
          value: "chinese"
        },
        {
          label: "英文",
          value: "english"
        },
        {
          label: "日期(如2018-04-26)",
          value: "date"
        },
        {
          label: "网址",
          value: "website"
        },
        {
          label: "身份证号码",
          value: "IDCard"
        },
        {
          label: "手机号码(仅支持大陆地区)",
          value: "phoneNumber"
        },
        {
          label: "电话号码(仅支持大陆地区)",
          value: "telephoneNumber"
        },
        {
          label: "QQ号",
          value: "qqNuamber"
        }
      ]
    };
  },
  props: ["tempQuesData", "isEditing", "ques", "config"],
  components: {
    wjQuillEditor
  },
  methods: {
    handleEditorChange(data) {
      this.tempQuesData.title = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.left20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/textarea.vue